import React from 'react';
import Badge from './';

const LocationBadge = ({location}) => {
  return (
    <Badge text={location} size="medium" type="locationChip" />
  );
};

export default LocationBadge;
